import { usePage } from "@inertiajs/vue3";
import { reactive, watch } from "vue";

type Schema<T> = {
  parse: (data: unknown) => T;
};

export function useValidatedProps<T extends object>(schema: Schema<T>) {
  const page = usePage();

  const validatedProps = reactive(schema.parse(page.props));

  watch(
    () => page.props,
    (props) => Object.assign(validatedProps, schema.parse(props)),
    { deep: true }
  );

  return validatedProps;
}
